import { render, staticRenderFns } from "./bookingtrenddash.vue?vue&type=template&id=fa0acb1e&"
import script from "./bookingtrenddash.vue?vue&type=script&lang=js&"
export * from "./bookingtrenddash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports